import { Search } from '../../../Assets/SVGS';
import { useTranslation } from 'react-i18next';
import './SearchInput.css'
function SearchInput({getSearchValue}){
  const { t } = useTranslation();
  return (
    <>
      <div className='search-input'>
        <div className='icon'>
          <Search width='25px' />
        </div>
        <input onChange={(e)=>getSearchValue(e)} type='search' placeholder={t('search')} />
      </div>
    </>
  );
}
export default SearchInput